export default __webpack_public_path__ + "static/media/archi_card2.44d764ce.webp";